(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nbg-product-picks"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nbg-bestsellers')) {
  customElements.define('nbg-bestsellers', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.observer.disconnect();
            this.loadProducts();
          }
        }, { rootMargin: '500px' });
        this.observer.observe(this);
      } else {
        this.loadProducts();
      }
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
    async loadProducts() {
      try {
        const response = await fetch(this.dataset.url, { credentials: 'same-origin' });
        if (!response.ok) return;
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = documentFragment.querySelector('[data-nbg-bestseller-grid]');
        if (!grid) return;
        const cards = Array.from(grid.querySelectorAll('[data-nbg-product-id]'));
        const picks = cards.filter((card) => card.dataset.nbgProductId !== this.dataset.productId).slice(0, 4);
        grid.replaceChildren(...picks);
        if (picks.length) this.querySelector('[data-nbg-bestseller-target]').replaceChildren(grid);
      } catch {}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbg-shop-intro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nbg-nugget-spotlight')) {
  customElements.define('nbg-nugget-spotlight', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('.nbg-spotlight__slide'));
      this.buttons = Array.from(this.querySelectorAll('[data-index]'));
      this.index = 0;
      if (!this.track || this.slides.length < 2) return;
      this.querySelector('[data-controls]').hidden = false;
      this.querySelector('[data-thumbs]').hidden = false;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-index')) this.show(Number(button.dataset.index));
        if (button.hasAttribute('data-direction')) this.show(this.index + Number(button.dataset.direction));
      });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update(Math.round(this.track.scrollLeft / this.track.clientWidth));
        });
      }, { passive: true });
    }
    show(index) {
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior });
    }
    update(index) {
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.buttons.forEach((button, position) => button.setAttribute('aria-pressed', String(position === this.index)));
      this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.querySelector('[data-direction="-1"]').disabled = this.index === 0;
      this.querySelector('[data-direction="1"]').disabled = this.index === this.slides.length - 1;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
